export enum ImportType {
    USER = <any>'User',
    GROUP = <any>'Group',
    ACCESS_CONTROL_SET = <any>'Access control set',
    SEARCH_RULE = <any>'Search rule',
    MASKING_RULE = <any>'Masking rule',
    LDAP_CONFIGURATION = <any>'LDAP configuration',
    RADIUS_CONFIGURATION = <any>'Radius configuration',
    EXTERNAL_AUTHENTICATION_GROUP_MAPPING = <any>'External authentication group mapping',
    TYPE_MAPPING = <any>'Type mapping',
    DASHBOARD = <any>'Dashboard',
    EVENT_MODELER_CONFIGURATION = <any>'Event modeler configuration',
    EVENT_EXTRACTOR_GROUP = <any>'Event extractor group',
    EVENT_EXTRACTOR_CONFIGURATION = <any>'Event extractor configuration',
    DICTIONARY_DEFINITION = <any>'Dictionary definition',
    DICTIONARY_ELEMENTS = <any>'Dictionary elements'

}